import React, { useEffect, useState } from "react";

import { Backdrop } from "../..";
import { SampleService } from "../../../services";
import { LabMachineAnalysisProps } from "../../../utils/types/components";
import { labMachineAnalysisUseStyle } from "../../../utils/styles";
import { Title } from "./Title";
import { Sample } from "./types";
import { MachineSamplesTableMap } from "./MachineSamplesTableMap";
import { Charts } from "./Charts";
import { Table } from "./Table";

export const LabMachineAnalysis = ({
  filters,
  hide = [],
  onLoading = () => true,
  showLoading = false,
}: LabMachineAnalysisProps): React.ReactElement => {
  const classes = labMachineAnalysisUseStyle();

  const [loading, setLoading] = useState(false);
  const [dataSamples, setDataSamples] = useState<Sample[]>([]);

  useEffect(() => {
    loadSamples();
  }, []);

  const changeLoading = (v: boolean) => {
    onLoading(v);
    setLoading(v);
  };

  const loadSamples = async () => {
    try {
      changeLoading(true);
      const data = await SampleService.find({
        unit: filters?.unit,
        subUnit: filters?.subUnit,
        faena: filters?.faena,
      });
      setDataSamples(data);
    } catch (e) {
      alert(e.message);
    } finally {
      changeLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      {showLoading && <Backdrop open={loading} />}

      {!hide.includes("sample-table") && (
        <>
          <Title>Tabla de Muestras</Title>

          <Table data={dataSamples} />
        </>
      )}
      {!hide.includes("sample-heat-map") && (
        <>
          <Title>Mapa de Calor</Title>

          <MachineSamplesTableMap
            data={dataSamples}
            showChart={!hide.includes("sample-charts")}
            subUnit={filters?.subUnit === "Motor" ? "engine" : "component"}
          />
        </>
      )}
    </div>
  );
};
